// extracted by mini-css-extract-plugin
export default {"container":"src-components-LinkModule-Components-NoResult-style-module__container--5aanN"};